// This file contains event names used for tracking user interactions

export const UserEvents = {
    SIGNUP: 'user_signed_up',
    LOGIN: 'user_logged_in',
    LOGOUT: 'user_logged_out',
    JOINED_COMPANY: 'user_joined_company',
};

export const ExpenseEvents = {
    CREATED: 'expense_created',
    EDITED: 'expense_edited',
    DELETED: 'expense_deleted',
    ACCURACY_VALIDATION: 'expense_accuracy_validation',
    IMAGE_SENT: 'expense_image_sent',
    REFUSED: 'manager_refused_expense',
};

export const ReportEvents = {
    CREATED: 'expense_report_created',
    SENT_TO_VALIDATION: 'expense_report_sent_to_validation',
    APPROVED: 'manager_approved_report',
    REFUSED: 'manager_refused_report',
};

export const CompanyEvents = {
    CREATED: 'company_created',
};

export const AccountantEvents = {
    EXPORT_ARCHIVED: 'accountant_archived_export',
};

export const ErrorEvents = {
    UPLOAD_ERROR: 'upload_error',
};

export const DuplicateEvents = {
    CONFIRMED: 'duplicate_suspicion_confirmed',
    DISMISSED: 'duplicate_suspicion_dismissed',
};
